<template>
  <div style="padding-bottom:35px" v-loading="loading">
    <!-- getRules -->
    <el-form ref="privsForm" :model="privsForm" label-width="120px" :rules="formPrivs">
      <el-form-item :label="$t('message.table.privilege')" prop="name">
        <el-input v-model="privsForm.name" size="small" :style="inputWidth"></el-input>
      </el-form-item>
      <el-form-item :label="$t('message.table.des')" prop="description">
        <el-input type="textarea" size="small" v-model="privsForm.description" :style="inputWidth"></el-input>
      </el-form-item>
      <el-form-item :label="$t('message.table.privilegeType')" prop="type">
        <el-select ref="slect" v-model="privsForm.type" :style="inputWidth" size="small"
          :placeholder="$t('message.placeholder.select')" @change="getType">
          <el-option :label="item.name" :value="item.id" v-for="item in privType" :key="item.id"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('message.table.dataType')" prop="classId">
        <el-cascader ref="cas" size="small" :style="inputWidth" :disabled="editList.includes(privsForm.type)"
          v-model="classId" :props="classProps" :options="options" :key="privsForm.type" @change="getClassId">
        </el-cascader>
      </el-form-item>

      <el-form-item :label="$t('message.table.criteria')" prop="criteria" v-if="getCriteria">
        <el-select v-model="privsForm.criteria" :style="inputWidth" size="small"
          :placeholder="$t('message.placeholder.select')" @change="changeCriteria" clearable>
          <el-option :label="item.name" :value="item.id" v-for="item in criteriaLists" :key="item.id"></el-option>
        </el-select>
      </el-form-item>

      <div v-if="statusVisible">
        <el-form-item :label="$t('message.table.workflow')" prop="workflow" v-show="workflowVisible">
          <el-select v-model="privsForm.workflowId" :style="inputWidth" size="small"
            :placeholder="$t('message.placeholder.select')" @change="getWorkflowId" clearable>
            <el-option :label="item.name" :value="item.id" v-for="item in workflowList" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('message.table.startStatus')">
          <ListData :listData="startField" @click="setChecked('start')" :style="inputWidth"></ListData>
        </el-form-item>
        <el-form-item :label="$t('message.table.endStatus')">
          <ListData :listData="endField" @click="setChecked('end')" :style="inputWidth"></ListData>
        </el-form-item>
      </div>

      <el-form-item :label="$t('message.table.applied')" v-if="applyTo">
        <ListData :listData="applyField" @click="setChecked()" :style="inputWidth"></ListData>
      </el-form-item>

      <el-dialog :close-on-click-modal="false" width="66%" center :title="dialogTitle" :visible.sync="dialogVisible"
        v-if="dialogVisible" append-to-body>

        <Transfer :data='generateData' :checkedData="checked" @sendTransferData='getTransferData' />

      </el-dialog>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <!-- <el-button size="small" @click="dialogVisible = false">{{
        $t("message.button.cancel")
      }}</el-button> -->
      <el-button size="small" type="primary" @click="getFormData" :loading="btnLoading">{{
        $t("message.button.affirm") }}</el-button>
    </span>
  </div>
</template>

<script>
import axios from "axios";
import ListData from "./privListData";
import Transfer from "./transfer.vue";
export default {
  data() {
    return {
      privsClassIdOptions: [],
      classProps: { checkStrictly: true },
      editList: [0, 11, 24, 25, 26, 27, 28, 29],
      privType: [],
      applyTo: false,
      statusVisible: false,
      workflowVisible: false,
      getCriteria: false,

      privClassId: [],

      checked: [],
      generateData: [],
      eData: [],

      workflowListArr: [],

      startField: [],
      endField: [],

      inputWidth: {
        width: "100%",
      },

      applyField: [],
      applyList: [],
      dialogVisible: false,
      dialogTitle: '',

      transType: "",

      btnLoading: false,
      btnDisabled: false,
      loading: false,

      privsForm: {
        name: "",
        classId: "",
        workflowId: "",
        type: 1,
        criteria: "",
      }, //添加数据


      classId: [],
      criteriaLists: [],
      checkedData: false,

      workflowList: [],
      formPrivs: {
        name: [
          {
            required: true,
            message: this.$t("message.tips.inputName"),
            trigger: "blur",
          },
          {
            min: 3,
            max: 40,
            message: this.$t("message.warning.length_107"),
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: this.$t("message.warning.blankRequired"),
            trigger: "blur",
          },
        ],


      },
      filterMethod(query, item) {
        return !query ? true : (item.label).toLowerCase().indexOf(query.toLowerCase()) > -1
      }
    };
  },
  props: ['privData'],
  components: { ListData, Transfer },
  // props: ["privType"],
  computed: {
    options() {
      const { type } = this.privsForm;
      let arr = [];
      if (type == 9) {
        arr = this.privsClassIdOptions.filter((i) => [104, 301, 401, 3011].includes(i.value));
        arr.map(i => {
          i.disabled = i.value == 301
          i.disabled && i.children.map(j => j.disabled = true);
        })
      } else if (type == 22 || type == 32) {
        arr = this.privsClassIdOptions.filter((i) => i.value == 104);
      }
      else {
        arr = this.privsClassIdOptions.filter((i) => i.value);
        arr.map((i) => { i.disabled = this.applyTo });
      }
      this.getCriteria = [2, 3, 4, 17, 21, 30].includes(type);
      this.applyTo = [2, 3].includes(type);
      this.statusVisible = [9, 22].includes(type);
      this.setFormAttri();
      return arr;
    },
    getRules() {
      const classId = [
        {
          required: true,
          message: this.$t("message.warning.blankRequired"),
          trigger: "change",
        },
      ]
      if (this.privsForm.type == 0) {
        return this.formPrivs
      }
      return { ...this.formPrivs, classId }
    },
  },
  watch: {


  },

  methods: {

    // filterMethod(query, item) {
    //   // return item.pinyin.indexOf(query) > -1;
    //   // console.log({query, item});
    // },
    changeCriteria() {
      this.$forceUpdate();
    },
    getType(id) {
      console.log(id);

      this.$forceUpdate();
      this.privsForm.classId = '';
      this.privsForm.workflowId = "";
      this.privsForm.criteria = ''
      this.classId = [];
      this.applyField = [],
        this.startField = [],
        this.endField = [],

        this.getCriteria = [2, 3, 4, 17, 21, 30].includes(id);
      this.applyTo = [2, 3].includes(id);
      this.statusVisible = [9, 22].includes(id);
      // if (id== 0) {
      //   this.classId = [101]
      //   this.privsForm.classId = 101;
      // }
    },
    getClassId(val) {
      console.log(val);

      if (!val.length) {
        this.classId = [];
        this.privsForm.classId = '';
        this.$nextTick(() => {
          console.log('sdfsdf');

          this.$refs.privsForm.clearValidate() // 只清除清除验证
        })
      }

      const e = this.classId;
      // console.log(e);
      if (e.length) {
        this.privsForm.classId = e[e.length - 1];
      }
      this.privsForm.workflowId = "";
      this.privsForm.criteria = '';

      this.applyField = [];
      this.startField = [];
      this.endField = [];

      this.$forceUpdate();
      this.setFormAttri();
    },
    setFormAttri() {
      const e = this.classId
      if (this.statusVisible && e.includes(301)) {
        this.getCriteria = true;
      }
      if (this.statusVisible && (e.includes(104) || e.includes(401) || e.includes(3011))) {
        this.workflowVisible = true
      }

      if (this.applyTo) {
        this.getAllAuthFields();
      }
      if (this.getCriteria) {
        this.getSeekList(this.privsForm.classId);
      }
      if (this.statusVisible && !this.workflowVisible) {
        this.getProjectStatus(this.privsForm.classId)
      }
      if (this.workflowVisible) {
        this.getWorkflowList(this.privsForm.classId);
        // this.getWorkflowId(this.privsForm.workflowId);
      }
    },
    getWorkflowList(e) {
      axios
        .get("pmdm/admin/workflow/getWorkflowByClsId?clsId=" + e)
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.workflowList = res.data.object.workflowList;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getSeekList(e) {
      axios
        .get("pmdm/admin/criteria/getSeekListByClsId?clsId=" + e)
        .then((res) => {
          if (res.data.code == 200) {
            this.criteriaLists = res.data.object.seekList;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getWorkflowId(e) {
      this.$forceUpdate();
      this.getWorkflowStatus(e).then(res => {
        console.log(res);
        this.generateData = res.data.object.map((i) => ({
          label: i.name,
          key: i.id,
          visible: i?.visibleType || 0
        }));
      });

    },

    async getWorkflowStatus(e) {
      const { data } = await axios.get('pmdm/admin/workflow/getAllStatus?workflowId=' + e);
      return { data }
    },

    getProjectStatus(res) {
      axios
        .get('/ppm/projectStatus/getStatusBySubclassId?subclassId=' + res)
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.generateData = res.data.object.projectStatusList.map((i) => ({
              label: i.name,
              key: i.id,
              visible: i?.visibleType || 0
            }));
          }
        })
        .catch((error) => {
          console.log(error);
        });
      this.$forceUpdate();
    },

    getTransferData(e) {
      const value = this.generateData.filter(i => e.includes(i.key) || e.includes(i.key + ''));
      if (this.transType == "start") {
        this.startField = value;
      } else if (this.transType == "end") {
        this.endField = value;
      } else {
        this.applyField = value;
      }
    },

    setChecked(e) {

      let keyList;
      if (e == "start") {

        keyList = this.startField.map((i) => i.key);

        this.dialogTitle = this.$t('message.table.startStatus')
      } else if (e == "end") {
        keyList = this.endField.map((i) => i.key);
        this.dialogTitle = this.$t('message.table.endStatus')
      } else {
        keyList = this.applyField.map((i) => i.key);
        this.dialogTitle = this.$t('message.table.applied')
      }
      this.checked = keyList;
      this.transType = e;
      this.dialogVisible = true;
    },
    getAllAuthFields() {
      if (!this.privsForm.classId) {
        return false;
      }

      let { classId: clsId, type: privType, parent } = this.privsForm;
      const obj = { clsId, privType, parent };
      axios
        .get(`pmdm/admin/priv/getAllAuthFields${this.params(obj)}`)
        .then((res) => {
          if (res.data.code == 200) {
            console.log(res);
            this.generateData = res.data.object.columnInfoVo.map((i) => ({
              key: i.classId,
              label: i.name,
              visiable: i?.visibleType || 0
            }));
          }
          this.applyField = this.generateData.filter(i => this.applyList.includes(i.key));
        })
        .catch((error) => {
          //console.log(error);
        });
    },

    async getPrivForm() {
      const { data: classList } = await axios.get(
        "/pmdm/admin/queryVirtualClassList"
      );
      return { classList };
    },

    getEditForm() {
      console.log(this.data);

      if (!this.data || !Object.keys(this.data).length) {
        return
      }
      this.privsForm = this.data.priv;
      this.applyList = this.data.priv.authFields.split(';')
      this.startField = this.data.startList.map((i) => ({
        label: i.name,
        key: i.id,
      }));
      this.endField = this.data.endList.map((i) => ({
        label: i.name,
        key: i.id,
      }));

      let type = this.privsForm.type;
      let id = this.privsForm.classId;
      // this.classProps = ;
      this.getCriteria = [2, 3].includes(type);
      this.applyTo = [2, 3].includes(type);
      this.statusVisible = [9, 22].includes(type);


      if (this.applyTo) {
        this.getAllAuthFields();
      }
      if (this.privsForm.classId) {
        let arr = this.getPar(this.privsClassIdOptions, { id: this.privsForm.classId });
        this.classId = arr.map(i => i.value).reverse();
        this.workflowVisible = this.statusVisible && (this.classId.includes(104) || this.classId.includes(401));
        if (this.statusVisible && this.classId.includes(301)) {
          this.getCriteria = true;
          this.getProjectStatus(this.privsForm.classId);
        }
        if (this.workflowVisible) {
          this.getWorkflowList(this.privsForm.classId);
          this.getWorkflowId(this.privsForm.workflowId);
        }
      }
      if (this.getCriteria) {
        this.getSeekList(this.privsForm.classId);
      }
    },

    getInfo() {


      this.loading = true;

      const list = [
        axios.get("/pmdm/admin/queryVirtualClassList"),
        axios.get("pmdm/admin/priv/getAllPrivType")
      ]

      Promise.all(list).then(res => {
        const [a, b] = res.map(i => i.data.object)
        // console.log(arr);
        this.privsClassIdOptions = a.clsList;
        this.privType = b.privType;

        if (!this.privData) {
          return ''
        } else {
          const { id } = this.$route.query
          if (id) {
            return axios.get("pmdm/admin/priv/getPriv?id=" + id)
          }
        }

      })
        .then(res => {
          if (!res) {
            return
          }
          this.data = res?.data.object;
          this.getEditForm();
        })
        .finally(_ => {
          this.loading = false
        })



      // axios.get(
      //   "/pmdm/admin/queryVirtualClassList"
      // )
      //   .then(res => {
      //     this.privsClassIdOptions = res.data.object.clsList;
      //     return axios
      //       .get("pmdm/admin/priv/getAllPrivType")
      //   }).then(res => {
      //     this.privType = res.data.object.privType;
      //     this.getEditForm();
      //     if (id) {
      //       return axios.get("pmdm/admin/priv/getPriv?id=" + id)
      //     }
      //   })
      //   .then(res => {
      //     this.data = res?.data.object || {};
      //   })
      //   .finally(_ => {
      //     this.loading = false
      //   })

      // this.getPrivForm().then((res) => {
      //   this.privsClassIdOptions = res.classList.object.clsList;
      //   this.getEditForm();

      // });
    },
    arrToStr(arr) {
      if (!arr) {
        return ''
      }
      const str = arr.map(i => i.key).join(';');
      return str
    },
    platArr(arr) {
      const list = [];

      const getVal = arr.map(i => {
        list.push(i);
        if (i?.children) {

        }
      })
    },

    getFormTypeData() {
      const typeValue = this.$refs.slect.selectedLabel;
      const className = (this.$refs.cas.inputValue || '').split('/').at(-1);
      return { typeValue, className }
    },
    getFormData() {
      this.$refs.privsForm.validate(async (valid) => {
        if (!valid) {
          return;
        } else {
          const arr = [this.applyField, this.startField, this.endField].map(i => this.arrToStr(i));
          const [authFields, workflowStartFields, workflowEndFields] = arr;

          const { className, typeValue } = this.getFormTypeData();
          const obj = { ...this.privsForm, typeValue, className, authFields, workflowStartFields, workflowEndFields };

          this.$emit('submit', obj)
          this.btnDisabled = false;
          this.btnLoading = false;
        }
      });
    },
  },
  created() {

    // if (this.privData) {
    //   this.privsForm = { ...this.privData };
    // } else {
    //   this.privsForm = {};

    // }
    this.privsForm = {};
    this.getInfo();
  },
};
</script>

<style scoped>
.dialog-footer {
  float: right;
  margin-right: 25px;
  /* margin-top: 35px; */
}

.is-grey {
  color: #cecece;
}
</style>
<style>
.el-select-dropdown__item {
  max-width: none;
}
</style>
